import React from "react";

import DemanderFormation from "./DemanderFormation";

export default function DemandesCollaborateur() {
    return <DemanderFormation />;
}
